export default __webpack_public_path__ + "static/media/top3.1e3f28c5.png";